import { atom } from 'jotai';

import type { LightOrDarkTheme } from './BlenderDirectory';

// Duplicating the atom set in DesignSystemProvider so it can diverge if necessary for the gallery
export const activeThemeAtom = atom<LightOrDarkTheme | null>(null);
